// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Client from "@apollo/client";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query promotionCampaignsByCku($cku: CKU!)  {\npromotionCampaignsByCku(cku: $cku, first: 50)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \nstartDate  \nendDate  \nformattedStatus  \ncreatorIdentifier  \nshop  {\n__typename  \nid  \nname  \n}\n\nprice  {\n__typename  \nid  \nname  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.promotionCampaignsByCku;
  let value$2 = value$1.edges;
  return {
    promotionCampaignsByCku: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.formattedStatus;
        let tmp;
        switch (value$2) {
          case "ARCHIVED" :
            tmp = "ARCHIVED";
            break;
          case "DRAFT" :
            tmp = "DRAFT";
            break;
          case "EXPIRED" :
            tmp = "EXPIRED";
            break;
          case "NOT_PROGRAMMED" :
            tmp = "NOT_PROGRAMMED";
            break;
          case "ONGOING" :
            tmp = "ONGOING";
            break;
          case "PROGRAMMED" :
            tmp = "PROGRAMMED";
            break;
          case "STOPPED" :
            tmp = "STOPPED";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$3 = value$1.shop;
        let value$4 = value$1.price;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            startDate: Scalar.Datetime.parse(value$1.startDate),
            endDate: Scalar.Datetime.parse(value$1.endDate),
            formattedStatus: tmp,
            creatorIdentifier: value$1.creatorIdentifier,
            shop: {
              __typename: value$3.__typename,
              id: value$3.id,
              name: value$3.name
            },
            price: {
              __typename: value$4.__typename,
              id: value$4.id,
              name: value$4.name
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.promotionCampaignsByCku;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.price;
    let value$3 = value$2.name;
    let value$4 = value$2.id;
    let value$5 = value$2.__typename;
    let price = {
      __typename: value$5,
      id: value$4,
      name: value$3
    };
    let value$6 = value$1.shop;
    let value$7 = value$6.name;
    let value$8 = value$6.id;
    let value$9 = value$6.__typename;
    let shop = {
      __typename: value$9,
      id: value$8,
      name: value$7
    };
    let value$10 = value$1.creatorIdentifier;
    let value$11 = value$1.formattedStatus;
    let formattedStatus = value$11 === "STOPPED" ? "STOPPED" : (
        value$11 === "ARCHIVED" ? "ARCHIVED" : (
            value$11 === "DRAFT" ? "DRAFT" : (
                value$11 === "NOT_PROGRAMMED" ? "NOT_PROGRAMMED" : (
                    value$11 === "ONGOING" ? "ONGOING" : (
                        value$11 === "EXPIRED" ? "EXPIRED" : "PROGRAMMED"
                      )
                  )
              )
          )
      );
    let value$12 = value$1.endDate;
    let value$13 = Scalar.Datetime.serialize(value$12);
    let value$14 = value$1.startDate;
    let value$15 = Scalar.Datetime.serialize(value$14);
    let value$16 = value$1.name;
    let value$17 = value$1.id;
    let value$18 = value$1.__typename;
    let node = {
      __typename: value$18,
      id: value$17,
      name: value$16,
      startDate: value$15,
      endDate: value$13,
      formattedStatus: formattedStatus,
      creatorIdentifier: value$10,
      shop: shop,
      price: price
    };
    let value$19 = value.__typename;
    return {
      __typename: value$19,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let promotionCampaignsByCku = {
    __typename: value$3,
    edges: edges
  };
  return {
    promotionCampaignsByCku: promotionCampaignsByCku
  };
}

function serializeVariables(inp) {
  return {
    cku: inp.cku
  };
}

function makeVariables(cku, param) {
  return {
    cku: cku
  };
}

let PromotionByCkuQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let PromotionByCkuQuery_refetchQueryDescription = include.refetchQueryDescription;

let PromotionByCkuQuery_use = include.use;

let PromotionByCkuQuery_useLazy = include.useLazy;

let PromotionByCkuQuery_useLazyWithVariables = include.useLazyWithVariables;

let PromotionByCkuQuery = {
  PromotionByCkuQuery_inner: PromotionByCkuQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: PromotionByCkuQuery_refetchQueryDescription,
  use: PromotionByCkuQuery_use,
  useLazy: PromotionByCkuQuery_useLazy,
  useLazyWithVariables: PromotionByCkuQuery_useLazyWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["query promotionCampaign($id: ID!, $after: String, $variantPricesFilterBy: InputVariantVariantPricesFilter)  {\npromotionCampaign(id: $id)  {\n__typename  \ndiscounts(first: 50, after: $after)  {\n__typename  \npageInfo  {\n__typename  \nendCursor  \nhasNextPage  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nid  \nvalue  \nkind  \nvariant  {\n__typename  \nid  \ncku  \nformattedName  \nformattedDescription  \nstockKeepingUnit  \npurchasedPrice  \ncapacityUnit  \nbulk  \nvariantPrices(filterBy: $variantPricesFilterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nvalueIncludingTax  \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.promotionCampaign;
  let tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    let value$2 = value$1.discounts;
    let value$3 = value$2.pageInfo;
    let value$4 = value$3.endCursor;
    let value$5 = value$3.hasNextPage;
    let value$6 = value$2.edges;
    tmp = {
      __typename: value$1.__typename,
      discounts: {
        __typename: value$2.__typename,
        pageInfo: {
          __typename: value$3.__typename,
          endCursor: !(value$4 == null) ? value$4 : undefined,
          hasNextPage: !(value$5 == null) ? value$5 : undefined
        },
        edges: value$6.map(value => {
          let value$1 = value.node;
          let value$2 = value$1.kind;
          let tmp;
          switch (value$2) {
            case "CURRENCY" :
              tmp = "CURRENCY";
              break;
            case "PERCENT" :
              tmp = "PERCENT";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          let value$3 = value$1.variant;
          let value$4 = value$3.stockKeepingUnit;
          let value$5 = value$3.purchasedPrice;
          let value$6 = value$3.capacityUnit;
          let value$7 = value$3.bulk;
          let value$8 = value$3.variantPrices;
          let value$9 = value$8.edges;
          return {
            __typename: value.__typename,
            node: {
              __typename: value$1.__typename,
              id: value$1.id,
              value: value$1.value,
              kind: tmp,
              variant: {
                __typename: value$3.__typename,
                id: value$3.id,
                cku: Scalar.CKU.parse(value$3.cku),
                formattedName: value$3.formattedName,
                formattedDescription: value$3.formattedDescription,
                stockKeepingUnit: !(value$4 == null) ? value$4 : undefined,
                purchasedPrice: !(value$5 == null) ? value$5 : undefined,
                capacityUnit: !(value$6 == null) ? value$6 : undefined,
                bulk: !(value$7 == null) ? value$7 : undefined,
                variantPrices: {
                  __typename: value$8.__typename,
                  edges: value$9.map(value => {
                    let value$1 = value.node;
                    return {
                      __typename: value.__typename,
                      node: {
                        __typename: value$1.__typename,
                        valueIncludingTax: value$1.valueIncludingTax
                      }
                    };
                  })
                }
              }
            }
          };
        })
      }
    };
  }
  return {
    promotionCampaign: tmp
  };
}

function serialize$1(value) {
  let value$1 = value.promotionCampaign;
  let promotionCampaign;
  if (value$1 !== undefined) {
    let value$2 = value$1.discounts;
    let value$3 = value$2.edges;
    let edges = value$3.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.variant;
      let value$3 = value$2.variantPrices;
      let value$4 = value$3.edges;
      let edges = value$4.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.valueIncludingTax;
        let value$3 = value$1.__typename;
        let node = {
          __typename: value$3,
          valueIncludingTax: value$2
        };
        let value$4 = value.__typename;
        return {
          __typename: value$4,
          node: node
        };
      });
      let value$5 = value$3.__typename;
      let variantPrices = {
        __typename: value$5,
        edges: edges
      };
      let value$6 = value$2.bulk;
      let bulk = value$6 !== undefined ? value$6 : null;
      let value$7 = value$2.capacityUnit;
      let capacityUnit = value$7 !== undefined ? value$7 : null;
      let value$8 = value$2.purchasedPrice;
      let purchasedPrice = value$8 !== undefined ? value$8 : null;
      let value$9 = value$2.stockKeepingUnit;
      let stockKeepingUnit = value$9 !== undefined ? value$9 : null;
      let value$10 = value$2.formattedDescription;
      let value$11 = value$2.formattedName;
      let value$12 = value$2.cku;
      let value$13 = Scalar.CKU.serialize(value$12);
      let value$14 = value$2.id;
      let value$15 = value$2.__typename;
      let variant = {
        __typename: value$15,
        id: value$14,
        cku: value$13,
        formattedName: value$11,
        formattedDescription: value$10,
        stockKeepingUnit: stockKeepingUnit,
        purchasedPrice: purchasedPrice,
        capacityUnit: capacityUnit,
        bulk: bulk,
        variantPrices: variantPrices
      };
      let value$16 = value$1.kind;
      let kind = value$16 === "PERCENT" ? "PERCENT" : "CURRENCY";
      let value$17 = value$1.value;
      let value$18 = value$1.id;
      let value$19 = value$1.__typename;
      let node = {
        __typename: value$19,
        id: value$18,
        value: value$17,
        kind: kind,
        variant: variant
      };
      let value$20 = value.__typename;
      return {
        __typename: value$20,
        node: node
      };
    });
    let value$4 = value$2.pageInfo;
    let value$5 = value$4.hasNextPage;
    let hasNextPage = value$5 !== undefined ? value$5 : null;
    let value$6 = value$4.endCursor;
    let endCursor = value$6 !== undefined ? value$6 : null;
    let value$7 = value$4.__typename;
    let pageInfo = {
      __typename: value$7,
      endCursor: endCursor,
      hasNextPage: hasNextPage
    };
    let value$8 = value$2.__typename;
    let discounts = {
      __typename: value$8,
      pageInfo: pageInfo,
      edges: edges
    };
    let value$9 = value$1.__typename;
    promotionCampaign = {
      __typename: value$9,
      discounts: discounts
    };
  } else {
    promotionCampaign = null;
  }
  return {
    promotionCampaign: promotionCampaign
  };
}

function serializeInputObjectStringEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeInputObjectInputVariantVariantPricesFilter(inp) {
  let a = inp.priceId;
  return {
    priceId: a !== undefined ? ({
        _equals: a._equals
      }) : undefined
  };
}

function serializeVariables$1(inp) {
  let a = inp.after;
  let a$1 = inp.variantPricesFilterBy;
  return {
    id: inp.id,
    after: a !== undefined ? a : undefined,
    variantPricesFilterBy: a$1 !== undefined ? serializeInputObjectInputVariantVariantPricesFilter(a$1) : undefined
  };
}

function makeVariables$1(id, after, variantPricesFilterBy, param) {
  return {
    id: id,
    after: after,
    variantPricesFilterBy: variantPricesFilterBy
  };
}

function makeInputObjectInputVariantVariantPricesFilter(priceId, param) {
  return {
    priceId: priceId
  };
}

function makeInputObjectStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

let PromotionDiscountsQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputVariantVariantPricesFilter: serializeInputObjectInputVariantVariantPricesFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  makeVariables: makeVariables$1,
  makeInputObjectInputVariantVariantPricesFilter: makeInputObjectInputVariantVariantPricesFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter
};

let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let PromotionDiscountsQuery_refetchQueryDescription = include$1.refetchQueryDescription;

let PromotionDiscountsQuery_use = include$1.use;

let PromotionDiscountsQuery_useLazy = include$1.useLazy;

let PromotionDiscountsQuery_useLazyWithVariables = include$1.useLazyWithVariables;

let PromotionDiscountsQuery = {
  PromotionDiscountsQuery_inner: PromotionDiscountsQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputVariantVariantPricesFilter: serializeInputObjectInputVariantVariantPricesFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  makeVariables: makeVariables$1,
  makeInputObjectInputVariantVariantPricesFilter: makeInputObjectInputVariantVariantPricesFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  refetchQueryDescription: PromotionDiscountsQuery_refetchQueryDescription,
  use: PromotionDiscountsQuery_use,
  useLazy: PromotionDiscountsQuery_useLazy,
  useLazyWithVariables: PromotionDiscountsQuery_useLazyWithVariables
};

function runScanDiscounts(discountsFetch, cursor, dataOpt, onDone, param) {
  let data = dataOpt !== undefined ? dataOpt : [];
  Future.mapOk(FuturePromise.fromPromise(discountsFetch(cursor)), undefined, response => {
    if (response.TAG !== "Ok") {
      return onDone("Error");
    }
    let match = response._0;
    let match$1 = match.data.promotionCampaign;
    if (match$1 === undefined) {
      return onDone("Error");
    }
    let match$2 = match$1.discounts;
    let match$3 = match$2.pageInfo;
    let match$4 = match$3.hasNextPage;
    if (match$4 !== undefined && match$4) {
      if (match.error !== undefined) {
        return onDone("Error");
      } else {
        return runScanDiscounts(discountsFetch, match$3.endCursor, Belt_Array.concatMany([
          data,
          match$2.edges
        ]), onDone, undefined);
      }
    }
    if (match.error !== undefined) {
      return onDone("Error");
    } else {
      return onDone({
        TAG: "Success",
        _0: Belt_Array.concatMany([
          data,
          match$2.edges
        ])
      });
    }
  });
}

export {
  PromotionByCkuQuery,
  PromotionDiscountsQuery,
  runScanDiscounts,
}
/* query Not a pure module */
